import chunk from 'lodash/chunk'
import size from 'lodash/size'
import get from 'lodash/get'
import indexOf from 'lodash/indexOf'
import https from '@/api/freight.js'

let source = [
    {
        label: '月份',
        name: 'monthly',
        items: [
            '1月',
            '2月',
            '3月',
            '4月',
            '5月',
            '6月',
            '7月',
            '8月',
            '9月',
            '10月',
            '11月',
            '12月'
        ],
        value: [
            '01',
            '02',
            '03',
            '04',
            '05',
            '06',
            '07',
            '08',
            '09',
            '10',
            '11',
            '12'
        ],
        colsCount: 6,
        typeCount: 1,
        code: '0',
        maxSelectedCount: 12
    },
    {
        label: '季度',
        name: 'quarterly',
        items: ['1季度', '2季度', '3季度', '4季度'],
        value: ['01', '02', '03', '04'],
        colsCount: 12,
        typeCount: 3,
        code: '1',
        maxSelectedCount: 12
    },
    {
        label: '半年度',
        name: 'semi-annual',
        items: ['上半年', '下半年'],
        value: ['01', '02'],
        colsCount: 12,
        typeCount: 6,
        code: '2',
        maxSelectedCount: 12
    },
    {
        label: '年度',
        name: 'annual',
        items: [
            '1月',
            '2月',
            '3月',
            '4月',
            '5月',
            '6月',
            '7月',
            '8月',
            '9月',
            '10月',
            '11月',
            '12月'
        ],
        value: [
            '01',
            '02',
            '03',
            '04',
            '05',
            '06',
            '07',
            '08',
            '09',
            '10',
            '11',
            '12'
        ],
        colsCount: 6,
        typeCount: 1,
        code: '3',
        maxSelectedCount: 12
    }
]
export let getDimensionSource = function () {
    return source
}
export let baseExportPrepare = function (that, year, index) {
    let selecedYear = year || that.selecedYear
    console.log(that.tab)
    if (that.moduleName === 'operateCollectionStat' || that.moduleName === 'operateCollectionStat_national') {
        let param = {
            year: '' + selecedYear,
            dateType: '' + that.tab,
            roadType: 'operateCollectionStat' == that.moduleName ? 1 : 2,
            dimension: that.tab == 2 ? '1' : '',
        }
        https.exportFreightDiscern3(param).then(e => {
            that.onResponse(e, index)
        })
    } else if (that.moduleName === 'wayRoadType') {
        let param = {
            year: '' + selecedYear,
            type: '' + that.tab
        }
        https.exportFreightDiscern_wayRoadType(param).then(e => {
            that.onResponse(e, index)
        })
    } else if (that.moduleName === 'wayRoadTypeTab2Detail') {
        let param = {
            year: '' + selecedYear,
            type: 'road_stop'
        }
        https.exportFreightDiscern_wayRoadType(param).then(e => {
            that.onResponse(e, index)
        })
        // exportFreightDiscern
    } else if (that.moduleName === 'wuliuCollectionStatV2') {
        // let param = getRequestParam(that, selecedYear)
        let type = that.tabObj.code
        let param = {
            ...that.params,
            moduleName: that.moduleName,
            year: selecedYear,
            type
        }
        https.exportFreightDiscern(param).then(e => {
            that.onResponse(e, index)
        })
        console.log(param, 'param')
    } else if (
        that.moduleName === 'vehicleWayCount' ||
        that.moduleName === 'pathwayCityOperator' ||
        that.moduleName === 'pathwayProvinceOil' ||
        that.moduleName === 'pathwayCityOil'
    ) {
        let param = getRequestParam(that, selecedYear)
        https.exportFreightDiscern_fuelType2(param).then(e => {
            that.onResponse(e, index)
        })
        console.log(param, 'param')
    } else if (that.moduleName === 'oilStationBerthProvinceV2' ||
        that.moduleName === 'oilStationBerthDetailV2' ||
        that.moduleName === 'oilStationBerthCountyV2'
    ) {
        console.log(that.params)
        let param = {
            ...that.params,
            type: that.tabObj.code,
            moduleName: that.moduleName,
            year: selecedYear,
        }
        // getRequestParam(that, selecedYear)
        https.exportFreightDiscern_fuelType23(param).then(e => {
            that.onResponse(e, index)
        })
        console.log(param, 'param')
    } else if (that.moduleName === 'pathwayProvinceOilV2') {
        console.log(that.params)
        let param = {
            ...that.params,
            type: that.tabObj.code,
            moduleName: that.moduleName,
            year: selecedYear,
        }
        // getRequestParam(that, selecedYear)
        https.exportFreightDiscern_fuelType24(param).then(e => {
            that.onResponse(e, index)
        })
        console.log(param, 'param')
    } else if (that.moduleName == 'wuliuCollectionStatV2') {
        let type = that.tabObj.code
        let param = {
            ...that.params,
            moduleName: that.moduleName,
            year: selecedYear,
            type
        }
        https.exportFreightDiscern_fuelTypeWuL(param).then(e => {
            that.onResponse(e, index)
        })
    } else {
        let param = getRequestParam(that, selecedYear)
        https.exportFreightDiscern_fuelType(param).then(e => {
            that.onResponse(e, index)
        })
    }
    // if (that.moduleName === 'wuliuCollectionStat') {
    //     let param = getRequestParam(that, selecedYear)
    //     https.exportFreightDiscern(param).then(e => {
    //         that.onResponse(e, index)
    //     })
    //     console.log(param, 'param')
    // }
}
export let getDimensionDescLabel = function (obj) {
    let it = get(source, obj.type, 0)
    let index = indexOf(it.value, obj.month)
    let label = get(it.items, index, '')
    return obj.year + '年 ' + label
}
export let getRequestParam = function (that, selecedYear) {
    let type = that.tabObj.code
    return {
        year: selecedYear,
        moduleName: that.moduleName,
        provinceCode: that.provinCode ? that.provinCode : '',
        provinceName: that.provinceName ? that.provinceName : '',
        region: that.cityName ? that.cityName : '',
        oilBrand: that.oilBrand ? that.oilBrand : '',
        pathwayCityCode: that.pathwayCityCode ? that.pathwayCityCode : '',
        roadCode: that.roadCode ? that.roadCode : '',
        type,
        timeType: type
    }
}
// 判断是否超过12个月
export let isCheckMore = function (that) {
    let maxSelectedCount = get(that, 'tabObj.maxSelectedCount', 0)
    let mouthData = that.mouthData
    let tempChooseArr = that.tempChooseArr
    let selecedYear = that.selecedYear
    var lens = 0
    if (tempChooseArr.length > 0) {
        for (var v of tempChooseArr) {
            lens += v.mouthArr.length
        }
    }
    if (lens >= maxSelectedCount) {
        // that.$message({
        //   message: '一次最多导出12个sheet',
        //   type: 'warning'
        // });
        for (var v of mouthData) {
            for (var k of tempChooseArr) {
                if (k.yearName == selecedYear) {
                    let mouthArr = k.mouthArr
                    if (mouthArr.indexOf(v.key) != -1) {
                        v.isDisabled = false
                    } else {
                        v.isDisabled = true
                    }
                } else {
                    v.isDisabled = true
                }
            }
        }
    } else {
        let mouthData = that.mouthData
        for (var v of mouthData) {
            if (v.isClick) {
                v.isDisabled = true
            } else {
                v.isDisabled = false
            }
        }
    }
}
export let exportExport = function (reqId, that, obj) {
    console.log(that)
    console.log(obj)
    // debugger
    let yearMonths = obj.values
    let moduleName = that.moduleName
    //  物流园停靠统计
    if (moduleName == 'wuliuCollectionStatV2') {
        // let param = getRequestParam(that, selecedYear)
        // let type = that.tabObj.code
        // let param = {
        //     ...that.params,
        //     moduleName:that.moduleName,
        //     year: selecedYear,
        //     type
        // }
        // var provCode = that.formData.provCityCounty[0] || ''
        // var cityCode = that.formData.provCityCounty[1] || ''
        // var countyCode = that.formData.provCityCounty[2] || ''
        // var tonnage = that.formData.dunwei
        var {
            provCodes,
            cityCodes,
            countyCodes,
            provCode,
            cityCode,
            countyCode,
            tonnage,
        } = that.params
        window.location.assign(
            https.exportTruck({
                yearMonths,
                reqId,
                provCodes,
                cityCodes,
                countyCodes,
                provCode,
                cityCode,
                countyCode,
                tonnage,
                type: obj.type
            })
        )
    }
    //  入网车辆吨位，运营车辆吨位，里程，运营时间 城市  导出
    if (moduleName == 'vehicleCountCity') {
        var province = that.provinceName
        var provinCode = that.provinCode
        var condition = that.condition
        window.location.assign(
            https.exportMoreData({
                yearMonths,
                reqId,
                province,
                provinCode,
                condition,
                type: obj.type
            })
        )
    }

    // 高速公路运营: operateCollectionStat   暂时注释掉，之后注意下是否影响了其他模块
    // if (moduleName == 'operateCollectionStat') {
    //     console.log('走')
    //     var type = that.tab + 1
    //     window.location.assign(
    //         https.carOperateDown({
    //             countTime: yearMonths,
    //             reqId,
    //             type
    //         })
    //     )
    // }
    if (['operateCollectionStat', 'operateCollectionStat_national'].includes(moduleName)) {
        console.log('走2')
        // var type = this.tab + 1
        console.log(that.tab)
        console.log(moduleName)
        console.log(that.moduleType)
        console.log(that.params)
        console.log(obj)
        var {
            provCodes,
            cityCodes,
            countyCodes,
            sourceGastype,
        } = that.params
        if (that.tab == 0) {
            window.location.assign(
                https.operateStatisticsExport({
                    countTime: yearMonths,
                    roadType: 'operateCollectionStat' == moduleName ? 1 : 2,
                    reqId,
                    moduleType: that.moduleType,
                    dateType: obj.type,
                    provCodes,
                    cityCodes,
                    countyCodes,
                    sourceGastype
                })
            )
        }
        if (that.tab == 1) {
            window.location.assign(
                https.addEnergyExport({
                    countTime: yearMonths,
                    roadType: 'operateCollectionStat' == moduleName ? 1 : 2,
                    reqId,
                    moduleType: that.moduleType,
                    dateType: obj.type,
                    provCodes,
                    cityCodes,
                    countyCodes,
                    sourceGastype
                })
            )
        }
        if (that.tab == 2) {
            window.location.assign(
                https.addEnergyStopInfoExport({
                    countTime: yearMonths,
                    roadType: 'operateCollectionStat' == moduleName ? 1 : 2,
                    reqId,
                    moduleType: that.moduleType,
                    dateType: obj.type,
                    provCodes,
                    cityCodes,
                    countyCodes,
                    sourceGastype
                })
            )
        }
    }
    //  加油站停靠统计: oilCollectionStat
    if (moduleName == 'oilCollectionStat') {
        let provinceName = that.provinceName
        let cityName = that.cityName
        let kind = that.oilBrand
        window.location.assign(
            https.carGasDowns({
                yearMonths: yearMonths ? yearMonths.split('-').join('') : '',
                reqId,
                provinceName,
                timeType: obj.type
            })
        )
    }
    //  途经各省品牌加油站停靠次数: pathwayProvinceOil
    if (moduleName == 'pathwayProvinceOil') {
        window.location.assign(
            https.vehiclStationExprot({
                yearMonths: yearMonths ? yearMonths.split('-').join('') : '',
                reqId,
                timeType: obj.type,
            })
        )
    }
    if (moduleName == 'oilStationBerthProvinceV2') {
        var {
            sourceGastype,
        } = that.params
        window.location.assign(
            https.oilStationBerthCountV2Ex({
                yearMonths: yearMonths ? yearMonths.split('-').join('') : '',
                reqId,
                dateType: obj.type,
                timeType: obj.type,
                sourceGastype
            })
        )
    }
    if (moduleName == 'oilStationBerthDetailV2') {
        console.log(that.params)
        var {
            provCode,
            cityCode,
            countyCode,
            provCodes,
            cityCodes,
            countyCodes,
            sourceGastype,
        } = that.params
        window.location.assign(
            https.oilStationBerthDetailV2Ex({
                yearMonths: yearMonths ? yearMonths.split('-').join('') : '',
                reqId,
                timeType: obj.type,
                dateType: obj.type,
                provCode,
                cityCode,
                countyCode,
                provCodes,
                cityCodes,
                countyCodes,
                sourceGastype,
            })
        )
    }
    if (moduleName == 'oilStationBerthCountyV2') {
        console.log(that.params)
        var {
            provCodes,
            cityCodes,
            countyCodes,
            provCode,
            cityCode,
            countyCode,
            sourceGastype,
        } = that.params
        window.location.assign(
            https.oilStationBerthCountyV2Ex({
                yearMonths: yearMonths ? yearMonths.split('-').join('') : '',
                reqId,
                timeType: obj.type,
                dateType: obj.type,
                provCode,
                cityCode,
                countyCode,
                provCodes,
                cityCodes,
                countyCodes,
                sourceGastype,
            })
        )
    }

    if (moduleName == 'pathwayProvinceOilV2') {
        var {
            provCode,
            sourceGastype,
        } = that.params
        window.location.assign(
            https.oilStationWayProvinceV2Ex({
                yearMonths: yearMonths ? yearMonths.split('-').join('') : '',
                reqId,
                timeType: obj.type,
                dateType: obj.type,
                provCode,
                sourceGastype,
            })
        )
    }
    //  途经各市品牌加油站停靠次数: pathwayCityOil
    if (moduleName == 'pathwayCityOil') {
        var pathwayProvcode = that.provinCode
        window.location.assign(
            https.exportCityExport({
                yearMonths,
                reqId,
                pathwayProvcode,
                timeType: obj.type,
            })
        )
    }
    //  物流园停靠统计: wuliuCollectionStat
    if (moduleName == 'wuliuCollectionStat') {
        window.location.assign(
            https.carLogisDown({
                dateType: obj.type,
                countTime: yearMonths,
                provinceCode: that.provinceName,
                cityCode: that.cityName,
                reqId
            })
        )
    }

    // a) 运营吨位分布批量导出
    if (moduleName == 'operatorTonVehicle') {
        window.location.assign(
            https.operatorVehicleExport({
                yearMonths: yearMonths,
                reqId,
                type: obj.type
            })
        )
    }
    if (moduleName == 'registerTonVehicle') {
        window.location.assign(
            https.carTonnageExport({
                yearMonths: yearMonths,
                reqId,
                type: obj.type
            })
        )
    }
    // b) 运营里程分布批量导出
    if (moduleName == 'operatorMileageVehicle') {
        window.location.assign(
            https.operatorMileageExport({
                yearMonths: yearMonths,
                reqId,
                type: obj.type
            })
        )
    }
    // c) 运营时间分布批量导出
    if (moduleName == 'operatorTimeVehicle') {
        window.location.assign(
            https.operatorTimeExport({
                yearMonths: yearMonths,
                reqId,
                type: obj.type
            })
        )
    }
    // c) 途经各省运营省车次/里程统计
    if (moduleName == 'vehicleWayCount') {
        let dataType = that.tab
        window.location.assign(
            https.carTrainsDown({
                time: yearMonths,
                timeType: obj.type,
                reqId,
                dataType
            })
        )
    }
    // c) 途经各省运营市车次/里程统计
    if (moduleName == 'pathwayCityOperator') {
        let dataType = that.tab
        let provinceName = that.$route.query.title || that.$route.query.provinceName
        console.log(that, provinceName, dataType, 'sdfadfsafdasfas')
        window.location.assign(
            https.carTrainsDetailExport({
                time: yearMonths,
                timeType: obj.type,
                reqId,
                provinceName,
                dataType
            })
        )
    }
    if (moduleName == 'wayRoadType') {
        var type = '' + that.tab
        window.location.assign(
            https.wayRoadExportV2({
                reqId,
                yearMonths,
                type,
                dateType: obj.type
            })
        )
    }
    if (moduleName == 'wayRoadTypeTab2Detail') {
        let provinceCode = that.provinCode
        window.location.assign(
            https.wayRoadExportV2Tab2Detail({
                reqId,
                range: yearMonths,
                provinceCode, //"11",
                dateType: obj.type
            })
        )
    }
    // 月均加油站停靠占比统计: vehiclePoiStopRadio
    if (moduleName == 'vehiclePoiStopRadio') {
        window.location.assign(
            https.stopProvinceStationExport({
                yearMonths: yearMonths,
                reqId
            })
        )
    }
}
